import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import { en, de, fr } from 'date-fns/locale'
//import localLang from 'date-fns/locale/de'

export default {

  methods: {
    formatDate(date, locale = "en") {

      const locales = { en, de, fr };

      const dateObj = date ? parseISO(date) : new Date();

      return format(dateObj, "PPPPp", { locale: locales[locale] });
    }
  }
}